import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from 'src/app/core/services/i18n.service';

@Pipe({
  name: 'translate',
  pure: false,
  standalone: false,
})
export class TranslatePipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  transform(key: string, params?: object): string {
    return this.i18n.translate(key, params);
  }
}
